
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gambling-help",
      function () {
        return require("private-next-pages/gambling-help.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gambling-help"])
      });
    }
  